import { successColor, hexToRgb } from 'assets/jss/material-dashboard-pro-react';

const successBoxStyle = () => ({
	boxWrapper: {
		width: '100%',
		borderRadius: 8,
		border: `solid 1px ${successColor[0]}`,
		backgroundColor: `rgba(${hexToRgb(successColor[0])}, 0.06)`,
		padding: '16px 24px',
	},
});

export default successBoxStyle;
